import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  role_id: null,
  role_name: null,
  role_desp: null,
  role_type: null,
  role_edit: false,
  roleIsPane: false,
  role_filter: true,
  addroleIsPane: false,
};
export const roleReducerInner = createSlice({
  name: "role",
  initialState: initialState,
  reducers: {
    role_id(state, action) {
      state.role_id = action.payload;
    },
    role_name(state, action) {
      state.role_name = action.payload;
    },
    role_desp(state, action) {
      state.role_desp = action.payload;
    },
    role_type(state, action) {
      state.role_type = action.payload;
    },
    role_edit(state, action) {
      state.role_edit = action.payload;
    },
    role_filter(state, action) {
      state.role_filter = action.payload;
    },
    role_IsPane(state, action) {
      state.roleIsPane = action.payload;
    },
    addrole_IsPane(state, action) {
      state.addroleIsPane = action.payload;
    },
  },
});
